export default "__VITE_ASSET__M7EA853S__"